import { render } from "./resend-confirmation-email.vue?vue&type=template&id=48c8e269"
import script from "./resend-confirmation-email.vue?vue&type=script&lang=js"
export * from "./resend-confirmation-email.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__